import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { type WorklistTask } from '@strata/react-worklist';

export interface WorklistSliceState {
    worklistTasks?: WorklistTask[];
    toDoTaskCount?: number;
}

const initialState: WorklistSliceState = {
    worklistTasks: undefined,
    toDoTaskCount: undefined,
};

export const worklistSlice = createSlice({
    name: 'worklist',
    initialState,
    reducers: {
        setWorklistTasks(state, action: PayloadAction<WorklistTask[] | undefined>) {
            return { ...state, worklistTasks: action.payload };
        },
        setWorklistToDoTaskCount(state, action: PayloadAction<number>) {
            return { ...state, toDoTaskCount: action.payload };
        },
        setWorklistTaskStatus(
            state,
            action: PayloadAction<{ taskId: string; status: WorklistTask['task_status'] }>,
        ) {
            const { taskId, status } = action.payload;
            return {
                ...state,
                worklistTasks: state.worklistTasks?.map((task) =>
                    task.task_id === taskId ? { ...task, task_status: status } : task,
                ),
            };
        },
    },
});

export const { setWorklistTasks, setWorklistTaskStatus, setWorklistToDoTaskCount } =
    worklistSlice.actions;
